import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1101"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.646 11.691c.09.016 1.414.24 2.964.24 1.01 0 2.115-.095 3.037-.406 3.709-1.249 6.14.067 6.239.122a.7.7 0 1 0 .694-1.215c-.064-.037-.908-.5-2.32-.722l.427-2.408 1.496.267a.357.357 0 0 0 .33-.588l-4.485-5.059a1.01 1.01 0 0 0-1.224-.223L2.74 4.877a.356.356 0 0 0 .103.667l1.507.27-.813 4.68c-.94-.062-1.636-.179-1.651-.181a.704.704 0 0 0-.809.57.698.698 0 0 0 .569.808zM7.2 10.199a5.901 5.901 0 0 1-1.072.238l.278-1.634a.602.602 0 0 1 .7-.492l2.136.382c.327.058.545.37.487.697l-.046.264c-.761.08-1.59.245-2.483.545zm7.382 2.894c-.123-.07-3.047-1.697-7.381-.233-1.997.674-5.281.117-5.314.112a.7.7 0 0 0-.239 1.379c.09.016 1.416.241 2.967.241 1.009 0 2.113-.096 3.034-.406 3.709-1.25 6.14.067 6.239.122.334.19.763.075.956-.26a.702.702 0 0 0-.262-.955z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }